module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp2_7042.3982bfef.png";